import { GENDERS, type SettingScope, genderScope, globalScope } from '@aysar/contracts';

/**
 * Every scope a `scopesAllowed: ['global', 'gender']` setting can be answered
 * at, least specific first.
 *
 * Derived from `GENDERS` rather than written out, so a new gender reaches every
 * surface that resolves a scoped setting without an edit here. It lives beside
 * the price board rather than inside it because two unrelated surfaces now
 * resolve a gender-scoped key — the direct prices, and the base a tier limit
 * inherits (P26b) — and a second copy of the list is a second thing to forget.
 */
export const SETTING_SCOPE_IDS = ['global', ...GENDERS] as const;

export type SettingScopeId = (typeof SETTING_SCOPE_IDS)[number];

/** One id back to the scope the api stores and resolves it under. */
export function scopeOfId(id: SettingScopeId): SettingScope {
  return id === 'global' ? globalScope() : genderScope(id);
}
